import classNames from "classnames"
import { FC } from "react"
import { Trans } from "react-i18next"

import styles from "./slide.module.css"
import { ISlideProps } from "./slide.type"
import Button from "../../../shared/ui/button/Button"
import { typographyColor, typographyType } from "../../../shared/ui/typography/constants"
import Typography from "../../../shared/ui/typography/Typography"

const Slide: FC<ISlideProps> = (
    {
        title,
        description,
        caption,
        additionalDescription,
        components,
        values,
        buttonText,
        buttonClassName,
        className,
        onButtonClick,
    }) => {
    const slideClassNames = classNames(
        styles.slide,
        className
    )
    return (
        <div className={slideClassNames}>
            <div className={styles.caption}>
                {caption && (
                    <Typography
                        type={ typographyType.body5 }
                        color={typographyColor.contrast}
                    >
                        <Trans i18nKey={caption} components={components} values={values} />
                    </Typography>
                )}
            </div>
            <div className={styles.bottomContent}>
                <div className={styles.textContainer}>
                    {title && (
                        <Typography
                            type={ typographyType.headline2 }
                            color={ typographyColor.primaryInverted }
                        >
                            <Trans i18nKey={title} components={components} values={values}/>
                        </Typography>
                    )}
                    {description && (
                        <Typography
                            type={ typographyType.headline1 }
                            color={typographyColor.contrast}
                        >
                            <Trans i18nKey={description} components={components} values={values}/>
                        </Typography>
                    )}
                    {additionalDescription && (
                        <Typography
                            type={ typographyType.body3 }
                            color={ typographyColor.contrast }
                        >
                            <Trans i18nKey={additionalDescription} components={components} values={values}/>
                        </Typography>
                    )}
                </div>
                {buttonText && (
                    <div className={styles.button}>
                        <Button
                            onClick={onButtonClick}
                            className={buttonClassName}
                            inverted
                        >
                            <Trans i18nKey={buttonText} components={components} values={values}/>
                        </Button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Slide
